import React, { useEffect, useRef } from 'react';
import { PlayerSambaVideosContainer } from './style';

declare let SambaPlayer: any;

export interface PlayerEventListener {
  event: string;
  eventParam?: any;
  duration?: any;
}

interface PlayerSambaVideosProps {
  contentReference: string;
  controlsToEnable?: string[];
  captionTheme?: string[];
  resume?: number;
  getEventListeners?: (eventListener: PlayerEventListener) => void;
}

const PlayerSambaVideos: React.FC<PlayerSambaVideosProps> = ({
  contentReference,
  controlsToEnable,
  captionTheme,
  resume,
  getEventListeners,
}) => {
  const playerContainer = useRef<HTMLDivElement>(null);
  const configurePlayer = () => {
    if (contentReference) {
      const playerBaseUrl = process.env.REACT_APP_PLAYER_BASE_URL || '';
      if (playerBaseUrl) {
        const contentReferenceWithoutBaseUrl = contentReference.replace(
          playerBaseUrl,
          '',
        );
        if (contentReferenceWithoutBaseUrl) {
          const splittedReference = contentReferenceWithoutBaseUrl.split('/');
          if (splittedReference && splittedReference.length > 1) {
            const playerHash = splittedReference[0];
            const midiaId = splittedReference[1];

            // clearAllMediaEvents: Limpa todos os eventos do player
            // Utilizado para evitar multiplas chamadas de vídeos já instanciados.
            SambaPlayer.clearAllMediaEvents();

            new SambaPlayer(playerContainer.current, {
              ph: playerHash,
              m: midiaId,
              playerParams: {
                enableControls: controlsToEnable,
                enableShare: false,
                resume: resume || false,
              },
              events: {
                '*': getEventListeners,
              },
            });
          }
        }
      }
    }
  };

  useEffect(() => {
    if (playerContainer && playerContainer.current) {
      if (Array.from(playerContainer.current.children).length > 0) {
        playerContainer.current.firstChild?.remove();
      }

      configurePlayer();
    }
  }, [playerContainer, contentReference]);

  return (
    <PlayerSambaVideosContainer
      ref={playerContainer}
    ></PlayerSambaVideosContainer>
  );
};

export default PlayerSambaVideos;
